import {Time, TimeInterval} from 'yougile-util'
import {Sync} from '@client/sync'
import {globals} from '@extensions/globals-base'
import {Task} from '@extensions/task'
import {Sticker, stickerCtl} from '../sticker'
import {StickerHub} from './a-sticker-view'

export const isTimerViewActive = (task?: StickerHub): boolean => {
  if (!task) {
    return false
  }
  const box = Sync.getCurrentSandbox()
  const hub = box.getHub(task.id)
  if (!hub) {
    return false
  }
  const board = Task.getBoardFromTask(hub)
  if (!board) {
    return false
  }
  const sticker = stickerCtl.Deadline.getSticker(box)
  const isStickerActiveInBoard = Sticker.isActiveInBoard(board, sticker)
  if (!isStickerActiveInBoard) {
    return false
  }
  const stickerSettings = board?.data.stickersSettings?.[sticker.id]

  return Boolean(stickerSettings?.hasDefaultState)
}

export const getTimerTime = (deadline: number): string => {
  const timeInterval = TimeInterval.fromDates(Time.now(), deadline).toString()

  return stickerCtl.Timer.formatTime({
    time: timeInterval, // e.g.: 0w1d5h0m0s
    by: globals.currentUserId, // used as a stub
    running: false, // used as a stub
    timestamp: Time.now() // used as a stub
  })
}
